(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-builder-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function init(root) {
      if (!root || root.dataset.pbReady) return;
      root.dataset.pbReady = '1';

      var cfgEl = root.querySelector('[data-pb-config]');
      var cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }
      var variants = cfg.variants || [];
      var T = cfg.texts;

      var $ = function (sel) {
        return root.querySelector(sel);
      };
      var $$ = function (sel) {
        return Array.prototype.slice.call(root.querySelectorAll(sel));
      };

      var fileInput = $('[data-pb-file]');
      var drop = $('[data-pb-drop]');
      var thumb = $('[data-pb-thumb]');
      var thumbImg = $('[data-pb-thumb-img]');
      var removeBtn = $('[data-pb-remove]');
      var fileError = $('[data-pb-file-error]');
      var keepBg = $('[data-pb-keep-bg]');
      var viewport = $('[data-pb-viewport]');
      var img = $('[data-pb-img]');
      var empty = $('[data-pb-empty]');
      var zoomRange = $('[data-pb-zoom]');
      var rotationRange = $('[data-pb-rotation]');
      var rotationValue = $('[data-pb-rotation-value]');
      var rotationStepButtons = $$('[data-pb-rotation-step]');
      var bgMessage = $('[data-pb-bg-message]');
      var tiles = $$('[data-pb-tile]');
      var totalEl = $('[data-pb-total]');
      var summaryEl = $('[data-pb-summary]');
      var alertEl = $('[data-pb-alert]');
      var addBtn = $('[data-pb-add]');
      var addText = $('[data-pb-btn-text]');

      var state = { loaded: false, nw: 0, nh: 0, zoom: 1, rotation: 0, u: 0.5, v: 0.5, objUrl: null };
      var busy = false;
      var raf = 0;

      var fmt;
      try {
        fmt = new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'EUR' });
      } catch (e) {
        fmt = {
          format: function (n) {
            return n.toFixed(2);
          },
        };
      }

      function clamp(n, a, b) {
        return Math.min(b, Math.max(a, n));
      }
      function showEl(el, on) {
        if (on) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }

      /* ---------- messages ---------- */
      function setFileError(msg) {
        fileError.textContent = msg || '';
        showEl(fileError, !!msg);
      }
      function setAlert(msg) {
        alertEl.textContent = msg || '';
        showEl(alertEl, !!msg);
      }

      /* ---------- options / price ---------- */
      function selected(group) {
        var el = root.querySelector('input[data-group="' + group + '"]:checked');
        return {
          label: el ? el.getAttribute('data-label') : '',
          price: el ? parseFloat(el.getAttribute('data-price')) || 0 : 0,
          variant: el ? el.getAttribute('data-variant') || '' : '',
        };
      }

      function findVariant() {
        if (!variants.length) return null;
        if (variants.length === 1) return variants[0];
        var wanted = ['enh', 'crop', 'holder']
          .map(function (g) {
            return selected(g).variant.trim().toLowerCase();
          })
          .filter(Boolean);
        if (!wanted.length) return null;
        for (var i = 0; i < variants.length; i++) {
          var opts = (variants[i].options || []).map(function (o) {
            return String(o).trim().toLowerCase();
          });
          var ok = wanted.every(function (w) {
            return opts.indexOf(w) !== -1;
          });
          if (ok) return variants[i];
        }
        return null;
      }

      function computeTotal() {
        var match = findVariant();
        if (match && variants.length > 1) return match.price / 100;
        var extras = selected('enh').price + selected('crop').price + selected('holder').price;
        var base = (match ? match.price : cfg.basePrice) / 100;
        return base + extras;
      }

      function updateSummary() {
        var bg = keepBg.checked ? T.bgOriginal : T.bgWhite;
        var parts = [T.caption, bg, selected('enh').label, selected('crop').label, selected('holder').label];
        summaryEl.textContent = parts.filter(Boolean).join('  |  ');
        totalEl.textContent = fmt.format(computeTotal());
        if (bgMessage) {
          bgMessage.textContent = keepBg.checked
            ? 'Tutte le foto manterranno lo sfondo originale, come mostrato nell anteprima.'
            : 'Lo sfondo di tutte le foto verrà sostituito con uno sfondo bianco per le foto di documenti.';
        }
      }

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (t && (t.matches('input[data-group]') || t === keepBg)) updateSummary();
      });

      /* ---------- crop engine ---------- */
      function frame() {
        return viewport.clientWidth || 1;
      }

      function geometry() {
        var f = frame();
        var base = Math.max(f / state.nw, f / state.nh);
        var s = base * state.zoom;
        var w = state.nw * s,
          h = state.nh * s;
        var x = clamp(f / 2 - state.u * w, f - w, 0);
        var y = clamp(f / 2 - state.v * h, f - h, 0);
        return { f: f, s: s, w: w, h: h, x: x, y: y };
      }

      function layout() {
        if (!state.loaded) return;
        var g = geometry();
        state.u = (g.f / 2 - g.x) / g.w;
        state.v = (g.f / 2 - g.y) / g.h;
        img.style.width = g.w + 'px';
        img.style.height = g.h + 'px';
        img.style.transformOrigin = 'center center';
        img.style.transform = 'translate(' + g.x + 'px,' + g.y + 'px) rotate(' + state.rotation + 'deg)';
        zoomRange.value = state.zoom;
        var pct = ((state.zoom - 1) / (3 - 1)) * 100;
        zoomRange.style.setProperty('--pb-fill', pct + '%');
        rotationRange.value = state.rotation;
        if (rotationValue) rotationValue.textContent = state.rotation + '°';
        rotationRange.style.setProperty('--pb-fill', ((state.rotation + 180) / 360) * 100 + '%');
        scheduleTiles();
      }

      function renderCanvas(size) {
        var g = geometry();
        var out = Math.max(300, Math.min(size, Math.round(g.f)));
        var c = document.createElement('canvas');
        c.width = c.height = out;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, out, out);
        ctx.imageSmoothingQuality = 'high';
        ctx.scale(out / g.f, out / g.f);
        ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
        ctx.rotate((state.rotation * Math.PI) / 180);
        ctx.drawImage(img, -g.w / 2, -g.h / 2, g.w, g.h);
        return c;
      }

      function scheduleTiles() {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          if (!state.loaded) return;
          var url = renderCanvas(520).toDataURL('image/jpeg', 0.85);
          tiles.forEach(function (t) {
            t.src = url;
            showEl(t, true);
          });
        });
      }

      function clearTiles() {
        tiles.forEach(function (t) {
          t.removeAttribute('src');
          showEl(t, false);
        });
      }

      /* drag */
      var drag = null;
      viewport.addEventListener('pointerdown', function (e) {
        if (!state.loaded) return;
        drag = { x: e.clientX, y: e.clientY, u: state.u, v: state.v, id: e.pointerId };
        viewport.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
        e.preventDefault();
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var g = geometry();
        state.u = drag.u - (e.clientX - drag.x) / g.w;
        state.v = drag.v - (e.clientY - drag.y) / g.h;
        layout();
      });
      function endDrag() {
        drag = null;
        viewport.classList.remove('is-dragging');
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      viewport.addEventListener(
        'wheel',
        function (e) {
          if (!state.loaded) return;
          e.preventDefault();
          state.zoom = clamp(state.zoom - e.deltaY * 0.0015, 1, 3);
          layout();
        },
        { passive: false }
      );

      zoomRange.addEventListener('input', function () {
        if (!state.loaded) return;
        state.zoom = clamp(parseFloat(zoomRange.value) || 1, 1, 3);
        layout();
      });

      rotationRange.addEventListener('input', function () {
        if (!state.loaded) return;
        state.rotation = clamp(parseFloat(rotationRange.value) || 0, -180, 180);
        layout();
      });

      rotationStepButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!state.loaded) return;
          state.rotation = clamp(
            state.rotation + parseInt(button.getAttribute('data-pb-rotation-step'), 10),
            -180,
            180
          );
          layout();
        });
      });

      $$('[data-pb-zoom-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!state.loaded) return;
          state.zoom = clamp(state.zoom + parseFloat(b.getAttribute('data-pb-zoom-step')), 1, 3);
          layout();
        });
      });

      $$('[data-pb-nudge]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!state.loaded) return;
          var d = b.getAttribute('data-pb-nudge').split(',').map(Number);
          var g = geometry();
          state.u += (d[0] * 12) / g.w;
          state.v += (d[1] * 12) / g.h;
          layout();
        });
      });

      if (window.ResizeObserver) new ResizeObserver(layout).observe(viewport);
      else window.addEventListener('resize', layout);

      /* ---------- file handling ---------- */
      function resetPhoto() {
        if (state.objUrl) {
          URL.revokeObjectURL(state.objUrl);
        }
        state = { loaded: false, nw: 0, nh: 0, zoom: 1, rotation: 0, u: 0.5, v: 0.5, objUrl: null };
        fileInput.value = '';
        img.removeAttribute('src');
        showEl(img, false);
        showEl(empty, true);
        viewport.classList.add('is-empty');
        showEl(thumb, false);
        thumbImg.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        zoomRange.value = 1;
        zoomRange.style.setProperty('--pb-fill', '0%');
        rotationRange.value = 0;
        if (rotationValue) rotationValue.textContent = '0°';
        rotationRange.style.setProperty('--pb-fill', '50%');
        rotationRange.disabled = true;
        rotationStepButtons.forEach(function (button) {
          button.disabled = true;
        });
        zoomRange.disabled = true;
        clearTiles();
      }

      function handleFile(file) {
        setFileError('');
        setAlert('');
        if (!file) return;
        if (!/^image\/(jpeg|png)$/i.test(file.type)) {
          setFileError(T.errType);
          return;
        }
        if (file.size > cfg.maxSizeMB * 1024 * 1024) {
          setFileError(T.errSize);
          return;
        }

        var url = URL.createObjectURL(file);
        var probe = new Image();
        probe.onload = function () {
          if (state.objUrl) URL.revokeObjectURL(state.objUrl);
          state.objUrl = url;
          state.nw = probe.naturalWidth;
          state.nh = probe.naturalHeight;
          state.zoom = 1;
          state.rotation = 0;
          state.u = 0.5;
          state.v = 0.5;
          state.loaded = true;
          img.onload = function () {
            layout();
          };
          img.src = url;
          showEl(img, true);
          showEl(empty, false);
          viewport.classList.remove('is-empty');
          thumbImg.src = url;
          showEl(thumb, true);
          zoomRange.disabled = false;
          rotationRange.disabled = false;
          rotationStepButtons.forEach(function (button) {
            button.disabled = false;
          });
          layout();
        };
        probe.onerror = function () {
          URL.revokeObjectURL(url);
          setFileError(T.errType);
        };
        probe.src = url;
      }

      fileInput.addEventListener('change', function () {
        handleFile(fileInput.files && fileInput.files[0]);
      });
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setFileError('');
        resetPhoto();
      });

      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault();
          drop.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault();
          drop.classList.remove('is-over');
        });
      });
      drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) handleFile(f);
      });

      /* ---------- add to cart ---------- */
      function setBusy(on) {
        busy = on;
        addBtn.disabled = on;
        addBtn.classList.toggle('is-loading', on);
        addText.textContent = on ? T.loading : T.button;
      }

      function canvasToBlob(canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(
            function (b) {
              b ? resolve(b) : reject(new Error('blob'));
            },
            'image/jpeg',
            0.92
          );
        });
      }

      function uploadImage(blob) {
        var fd = new FormData();
        fd.append('image', blob, 'photo-kit.jpg');
        return fetch('https://api.imgbb.com/1/upload?key=' + encodeURIComponent(cfg.apiKey), {
          method: 'POST',
          body: fd,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (j) {
            if (!j || !j.success || !j.data) throw new Error('upload');
            return j.data.url || j.data.display_url;
          });
      }

      addBtn.addEventListener('click', function () {
        if (busy) return;
        setAlert('');

        if (!state.loaded) {
          setFileError('');
          setAlert(T.errNoPhoto);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (!cfg.apiKey) {
          setAlert(T.errUpload);
          return;
        }

        var variant = findVariant();
        if (!variant) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].available) {
              variant = variants[i];
              break;
            }
          }
          if (!variant) variant = variants[0];
          if (variants.length > 1)
            console.warn(
              '[photo-kit-builder] No variant matched the selected options; using the first available variant.'
            );
        }
        if (!variant) {
          setAlert(T.errCart);
          return;
        }

        setBusy(true);
        var photoUrl;

        canvasToBlob(renderCanvas(1200))
          .then(uploadImage)
          .then(function (url) {
            photoUrl = url;
            var props = {};
            props[cfg.names.photo] = photoUrl;
            props[cfg.names.bg] = keepBg.checked ? T.bgOriginal : T.bgWhite;
            props[cfg.names.enh] = selected('enh').label;
            props[cfg.names.crop] = selected('crop').label;
            props[cfg.names.holder] = selected('holder').label;
            props[cfg.names.format] = T.caption;

            return fetch(cfg.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: props }] }),
            });
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(
                function (j) {
                  throw new Error((j && (j.description || j.message)) || 'cart');
                },
                function () {
                  throw new Error('cart');
                }
              );
            }
            // window.location.reload();
            document.dispatchEvent(
              new CustomEvent('my-cart:refresh-and-open')
            );
            setBusy(false);
          })
          .catch(function (err) {
            var m = err && err.message;
            setAlert(
              m === 'upload' || m === 'blob' || m === 'Failed to fetch'
                ? T.errUpload
                : m && m !== 'cart'
                ? m
                : T.errCart
            );
            setBusy(false);
          });
      });

      /* ---------- boot ---------- */
      resetPhoto();
      updateSummary();
    }

    function initAll() {
      document.querySelectorAll('[data-pb]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector('[data-pb]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
